import HeaderOuter from "../../components/layout/HeaderOuter";
import FooterOuter from "../../components/layout/FooterOuter";
import "../../assets/css/plugins.css";
import "../../assets/css/rev_slider/settings.css";
import "../../assets/css/rev_slider/layers.css";
import "../../assets/css/rev_slider/navigation.css";
import "../../assets/quform/css/base.css";
import "../../assets/search/search.css";
import "../../assets/css/styles.css";
import "../../assets/css/custom.css";
import TestimonialsComponent from "../../components/outer/TestimonialsComponent";

const Testimonials: React.FC = (props) => {
    return (
        <div className="main-wrapper" >
            <HeaderOuter />
            <TestimonialsComponent />
            <FooterOuter />
            <a href="#top" className="scroll-top" title="Back to top" aria-label="Scroll to top">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 19V6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 12l7-7 7 7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </a>
        </div>
    );
};
export default Testimonials;